interface Props {
  message: string;
  onRetry?: () => void;
}

export function ErrorBanner({ message, onRetry }: Props) {
  return (
    <div className="flex items-center justify-between gap-3 rounded-xl border border-rose-500/30 bg-rose-500/10 px-4 py-3 text-sm text-rose-300">
      <span>⚠️ {message}</span>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="shrink-0 rounded-lg bg-rose-500/20 px-3 py-1 font-semibold text-rose-200 transition hover:bg-rose-500/30"
        >
          Retry
        </button>
      )}
    </div>
  );
}
